import _ from "lodash";
import Entity from "entity";
import { getAllIndicadores } from "entity/Indicador/all";
import { filterSelectInput } from "components/form/DefaultConsultView/components/FilterInputs";
import getAllTiposIndicador from "entity/TipoIndicador/all";
import { version } from "process";

export default class Cliente extends Entity {
    static get collectionUID() {
        return "ValueCustomForm/bsCJi5q1HonJ4ZgKYZUi/Values";
    }

    async initialize() {
        this.data.status = "ATIVO";
        this.data.anexos = null;
    }

    async onLoad() {
        //this.migrateLegacyParams();
    }

    static async onQuery(collection) {
        return collection.where("status", "==", "ATIVO");
    }

    static get labelField() {
        return "nome";
    }

    static get searchColumns() {
        return [
            { field: "sequencialIndex", headerName: "Código", flex: 0.5, filter: true },
            { field: "dataLastChangeStr", headerName: "Data Alteração", flex: 1 },
            { field: "nome", headerName: "Nome", flex: 4, filter: true },
            {
                field: "status",
                headerName: "Status",
                flex: 1,
                filter: filterSelectInput("status", "Status", ["ATIVO", "INATIVO", "DELETAR"]),
            },
            {
                field: "perfisAutorizado",
                headerName: "QT Técnicos",
                flex: 1,
                valueGetter: (v) => {
                    let perfisAutorizado = v.row.perfisAutorizado;
                    if (perfisAutorizado) {
                        return Object.values(perfisAutorizado).filter((v) => v).length;
                    }
                    return "-";
                },
            },
        ];
    }

    /**
     * Campo em que são armazenados os parâmetros de indicador.
     */
    get paramField() {
        return "params";
    }

    /**
     * Adiciona um parâmetro de indicador.
     */
    addParam(name, value = {}) {
        _.set(this.data, `${this.paramField}.${name}`, value);
    }

    /**
     * Remove um parâmetro de indicador.
     */
    removeParam(name) {
        _.unset(this.data, `${this.paramField}.${name}`);
    }

    hasParam(name) {
        return _.has(this.data, `${this.paramField}.${name}`);
    }

    /**
     * Retorna os parâmetros do indicador de um tipo (Manual ou Mecanizado).
     */
    parseNewParams() {
        if (!this.data.params.versionData || this.data.params.versionData < 1) {
            let newp = { versionData: 1 };

            getAllTiposIndicador().forEach((TipoIndicador) => {
                // console.log("TipoIndicador", TipoIndicador);
                TipoIndicador.indicadores.forEach((Indicador) => {
                    // console.log("Indicador", Indicador);
                    let pMe = _.get(this.data.params, TipoIndicador.field + "." + Indicador.field + "." + "mecanizado");

                    if (pMe) {
                        // _.set(newp, TipoIndicador.field + "." + Indicador.field + "." + "mecanizado",pMe)
                    } else {
                        pMe = _.get(this.data.params, Indicador.field + TipoIndicador.field + "." + "mecanizado");
                        if (pMe) {
                            _.set(newp, TipoIndicador.field + "." + Indicador.field + "." + "mecanizado", pMe);
                        } else {
                            pMe = _.get(this.data.params, Indicador.field + "." + "mecanizado");
                            if (pMe) {
                                _.set(newp, TipoIndicador.field + "." + Indicador.field + "." + "mecanizado", pMe);
                            }
                        }
                    }

                    let pMa = _.get(this.data.params, TipoIndicador.field + "." + TipoIndicador.field + "." + "manual");
                    if (pMa) {
                        // _.set(newp, TipoIndicador.field + "." + Indicador.field + "." + "manual",pMa)
                    } else {
                        pMa = _.get(this.data.params, Indicador.field + TipoIndicador.field + "." + "manual");
                        if (pMa) {
                            _.set(newp, TipoIndicador.field + "." + Indicador.field + "." + "manual", pMa);
                        } else {
                            pMa = _.get(this.data.params, Indicador.field + "." + "manual");
                            if (pMa) {
                                _.set(newp, TipoIndicador.field + "." + Indicador.field + "." + "manual", pMa);
                            }
                        }
                    }
                });
            });

            this.data.params = newp;
        }
    }

    getParams(IndicadorClass, tipo, TipoClass) {
        tipo = tipo.toLowerCase();

        if (this.data.params) {
            this.parseNewParams();
            return _.get(this.data.params, TipoClass?.field + "." + IndicadorClass.field + "." + tipo);
        }
        return null;
    }

    getAllParams(IndicadorClass, TypeClass) {
        if (this.data.params) {
            return _.get(this.data.params, TypeClass?.field + "." + IndicadorClass?.field);
            // let field = IndicadorClass.field + (TypeClass?.field || "");
            // let indicadorField = IndicadorClass.field
            // let tipoIndicadorField = TypeClass?.field
            // let get = _.get(this.data.params[tipoIndicadorField], indicadorField)

            // if (this.data.params[tipoIndicadorField] && get) {
            //     return get
            // }

            // // if (this.data.params[field]) {
            // //     return this.data.params[field];
            // // }

            // if (this.data.params[IndicadorClass.field]) {
            //     return this.data.params[IndicadorClass.field];
            // }
        }
    }

    static getParamsClienteData(clienteData, IndicadorClass, tipo, TipoIndicadorClass) {
        let cliente = new Cliente();
        cliente.update(clienteData);
        if (tipo) {
            tipo = tipo.toLowerCase();
        } else {
            tipo = "manual";
            // indicadores que são somente mecanizado (getIndicadoresMecanizado)
            if (
                [
                    "acs",
                    "adh",
                    "adn",
                    "afc",
                    "ah",
                    "arsub",
                    "as",
                    "ibf",
                    "ipsp",
                    "pc",
                    "perd",
                    "piso",
                    "TAH",
                    "tmt",
                    "tmm",
                    "ttc",
                    "uql",
                ].includes(IndicadorClass.field)
            ) {
                tipo = "mecanizado";
            }
        }
        return cliente.getParams(IndicadorClass, tipo, TipoIndicadorClass);

        //     // indicadores que são somente manual (getIndicadoresManual)
        //     else if (["falhas", "lc", "perf", "lbm", "pcorte", "pragasolo"].includes(IndicadorClass.field)) {
        //         tipo = "manual";
        //     }
        //     // indicadores que podem ser mecanizado ou manual: nesse caso é usada a meta Manual do indicador (getIndicadoresManualMecanizado)
        //     // NGV, ADF, EES, VCC, PS, AltC, ADC, PDT, TTP, BA, AVL, mudaMecanizada
        // }

        // const field =
        //     TipoIndicadorClass && TipoIndicadorClass.field
        //         ? IndicadorClass.field + TipoIndicadorClass.field
        //         : IndicadorClass.field;

        // if (clienteData && clienteData.params) {
        //     if (clienteData.params[field]) {
        //         // console.log("clienteData.params[field][tipo] ", clienteData.params[field][tipo]);
        //         return clienteData.params[field][tipo];
        //     }

        //     if (clienteData.params[IndicadorClass.field]) {
        //         // console.log("clienteData.params[IndicadorClass.field][tipo] ", clienteData.params[IndicadorClass.field][tipo]);
        //         return clienteData.params[IndicadorClass.field][tipo];
        //     }
        // } else {
        //     return null;
        // }

        // // if (clienteData && clienteData.params && clienteData.params[field]) {
        // //     return clienteData.params[field][tipo];
        // // } else {
        // //     return null;
        // // }
    }

    /**
     * Retorna parâmetros dos Pontos Amostrados do indicador.
     */
    getParamItems(IndicadorClass, tipo) {
        if (tipo) {
            tipo = tipo.toLowerCase();
        }
        const field = IndicadorClass.field;

        if (this.data.params && this.data.params[field]) {
            if (
                (tipo === "manual" || tipo === "mecanizado") &&
                this.data.params[field][tipo] &&
                this.data.params[field][tipo]["items"]
            ) {
                // Manual tem seus próprios items de parâmetros e Mecanizado tem seus próprios
                // this.data.params.ttp.manual.items ou this.data.params.ttp.mecanizado.items
                return this.data.params[field][tipo]["items"];
            } else {
                // items de parâmetros são os mesmos para Manual e para Mecanizado
                // this.data.params.ttp.items
                return this.data.params[field]["items"];
            }
        } else {
            return null;
        }
    }

    /**
     * Migra parâmetros do formato antigo para o novo.
     */
    migrateLegacyParams(force) {
        console.log("migrateLegacyParams cliente");

        if (!force && this.data.params) {
            // Migração já realizada.
            console.log("Migração já realizada");
            return;
        }

        for (const IndicadorClass of getAllIndicadores()) {
            const paramMap = IndicadorClass.legacyParamMap;

            for (const param in paramMap) {
                let newField;
                let value;

                if (paramMap[param].type === Array) {
                    newField = `params.${IndicadorClass.field}.${paramMap[param].newField}`;
                    const array = _.get(this.data, param);

                    if (array) {
                        value = array.map((value) => {
                            // Converte cada elemento do array de acordo com o mapa de parâmetros.
                            const result = {};
                            const arrayParamMap = paramMap[param].paramMap;

                            for (const key in arrayParamMap) {
                                let itemValue = _.get(value, key);
                                if (itemValue === undefined) {
                                    itemValue = null;
                                }
                                _.set(result, arrayParamMap[key], itemValue);
                            }

                            return result;
                        });
                    }
                } else {
                    newField = `params.${IndicadorClass.field}.${paramMap[param]}`;
                    value = _.get(this.data, param);
                }

                if (newField && value) {
                    _.set(this.data, newField, value);

                    // TODO: remover antigo?
                }
            }
        }
        this.notify();
    }
}
